module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-greenhousegas.efdca0a3.svg";